export class mdlPayFortRequestDetailsRes {
    
    public command: string;
    public access_code: string;
    public merchant_identifier: string;
    public merchant_reference: string;
    public amount: string;
    public currency: string;
    public language: string;
    public customer_email: string;
    public signature: string;
    public token_name :string;
    public payment_option: string;
    public sadad_olp: string;
    public eci: string;
    public order_description: string;
    public customer_ip: string;
    public customer_name: string;
    public merchant_extra :string;
    public merchant_extra1 :string;
    public merchant_extra2 :string;
    public merchant_extra3 :string;
    public merchant_extra4 :string;
    public remember_me :string;
    public phone_number :string;
    public settlement_reference:string;
    public return_url: string;
    public Status_Code: string;
    public Error_Msg: string;
    public RESULT:string;
    public ERROR_MSG:string;


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPayFortRequestDetailsRes.ts